import { gsap } from "gsap";

import './basic-effect.scss';

export class BasicEffect {

	constructor( el: HTMLElement ) {
		gsap.to(el, {
			top: 0,
			opacity: 1
		});
	}

}
